/* Publish by EComposer at 2026-10-14 06:11:05*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-fxlc8pyqh14"]=  window.__ectimmers["ecom-fxlc8pyqh14"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),s=t.querySelector(".text-content.ecom-html");!s||(e&&e.addEventListener("click",()=>{s.classList.remove("ecom-text--is-mark"),s.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{s.classList.add("ecom-text--is-mark"),s.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-fxlc8pyqh14').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fxlc8pyqh14', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3e5f9mntbfz').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3e5f9mntbfz', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-74tdtfngu37').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-74tdtfngu37', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6hmdp0wy61n').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6hmdp0wy61n', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-r0c1glpxj3k').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-r0c1glpxj3k', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-o2ck7y5zj9m').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-o2ck7y5zj9m', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-s4uafcoauh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-s4uafcoauh', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9ao7tr5px2q').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9ao7tr5px2q', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fho1qjnrh1').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fho1qjnrh1', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-id09qzvaq4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-id09qzvaq4', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0tvp250axvci').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0tvp250axvci', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-k97nj1qeny').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-k97nj1qeny', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vg973w0ixoo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vg973w0ixoo', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-cm234k7htvh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-cm234k7htvh', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qg1som66cxm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qg1som66cxm', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-d352mh50l9i').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-d352mh50l9i', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5bd9a5qo44').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5bd9a5qo44', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9f7k2v46qoq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9f7k2v46qoq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-dk4px4prq5v').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-dk4px4prq5v', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-apzfovu3s1l').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-apzfovu3s1l', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gd088hzplnp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gd088hzplnp', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-n3qgoxwq6yc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-n3qgoxwq6yc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-37u19uri97b').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-37u19uri97b', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ph9z7rz5s8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ph9z7rz5s8', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1iwakrbmf6j').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1iwakrbmf6j', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-lv9s07endmo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lv9s07endmo', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-arwldvppsh7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-arwldvppsh7', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-n521zrkgit').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-n521zrkgit', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-pwoplhijdzo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pwoplhijdzo', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1i6mtil6qdj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1i6mtil6qdj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6nk1afr3lrt').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6nk1afr3lrt', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-z52f5mygemj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-z52f5mygemj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-brua1lnjjzd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-brua1lnjjzd', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-egk0stle1rq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-egk0stle1rq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2mvfrnbnph6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2mvfrnbnph6', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-da6esrzvdy').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-da6esrzvdy', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-65ocb6tfhqn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-65ocb6tfhqn', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mr17w0tbvt').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mr17w0tbvt', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-n0p57agy1mf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-n0p57agy1mf', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ugr1m185u1s').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ugr1m185u1s', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6qpuf7kloct').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6qpuf7kloct', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9pwtnjccrhn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9pwtnjccrhn', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jarp2pzh0g').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jarp2pzh0g', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-00hsljkogxjov').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-00hsljkogxjov', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-pzzwmbowij').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pzzwmbowij', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qbql5m5pvy8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qbql5m5pvy8', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-j5o5mczluno').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-j5o5mczluno', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2s0giusnynl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2s0giusnynl', settings: {},isLive: true});
                        });
                    

                })();
            